// App state management
export default {
  namespaced: true,

  state: {
    isLoadingComplete: false,
    nonCriticalDepsLoaded: false,
    performanceMetrics: {
      appLoadTime: null,
      lcpTime: null,
      firstInteractionTime: null
    }
  },

  mutations: {
    SET_LOADING_COMPLETE(state, isComplete) {
      state.isLoadingComplete = isComplete
    },

    SET_NON_CRITICAL_DEPS_LOADED(state, isLoaded) {
      state.nonCriticalDepsLoaded = isLoaded
    },

    SET_PERFORMANCE_METRIC(state, { metric, value }) {
      state.performanceMetrics[metric] = value
    }
  },

  actions: {
    markLoadingComplete({ commit }) {
      commit('SET_LOADING_COMPLETE', true)
    },

    markNonCriticalDepsLoaded({ commit }) {
      commit('SET_NON_CRITICAL_DEPS_LOADED', true)
    },

    recordPerformanceMetric({ commit }, { metric, value }) {
      commit('SET_PERFORMANCE_METRIC', { metric, value })
    }
  },

  getters: {
    isAppReady: (state) => {
      return state.isLoadingComplete && state.nonCriticalDepsLoaded
    },

    loadingStatus: (state) => {
      if (!state.isLoadingComplete) return 'loading'
      if (!state.nonCriticalDepsLoaded) return 'loaded'
      return 'ready'
    }
  }
}